<template>
  <Adminlte>
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary center-block">
          <div class="box-header with-border">
            <h3 class="box-title">Responder Questionário</h3>
            <form role="form" v-if="this.questionsByAxis">
              <div class="box-body">
                <tabs class="nav-tabs-custom" :value="this.activeAxis" v-on:active="setActiveAxis">
                  <tab v-for="(axis, index) in Object.keys(this.questionsByAxis)" :header="axisHeader(axis)" :key="index">
                    <component
                      v-for="q in questionsByAxis[axis]"
                      v-if="quiz && q.isVisible"
                      v-bind:key="q.uuid"
                      ref="questions"
                      v-on:answerUpdated="onAnswerUpdated"
                      :is="getQuestionComponent(q)"
                      :question="q"
                      :answer="getQuestionAnswer(q)"
                      :quizAnswers="quiz.answers">
                    </component>
                  </tab>
                </tabs>
              </div>

              <div class="box-footer">
                <button type="button"
                  class="btn btn-sm btn-success pull-right"
                  data-toggle="modal"
                  data-target="#send-for-approval-modal"
                  :disabled="!isQuizAllowedToBeSent">
                  <i class="fa fa-send"></i>&nbsp; Enviar
                </button>
                <button type="submit" class="btn btn-sm btn-primary pull-right" v-on:click.prevent="onSubmit">
                  <i class="fa fa-save"></i>&nbsp; Salvar
                </button>
                <go-back-button></go-back-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <notifier ref="notifier"></notifier>
    <!-- Modal -->
    <div class="modal fade" id="send-for-approval-modal" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">Enviar Questionário</h4>
          </div>
          <div class="modal-body">
            <p>Ao clicar em "Ok" o questionário será enviado e não será mais possível alterar as respostas. Deseja continuar?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal">Cancelar</button>
            <button type="button" class="btn btn-primary" @click="sendQuiz()">Ok</button>
          </div>
        </div>
      </div>
    </div>
  </Adminlte>
</template>

<script>
import { tabs, tab } from 'vue-strap'

import Adminlte from '@/components/template/Adminlte'
import GoBackButton from '@/components/elements/GoBackButton'
import Notifier from '@/components/elements/Notifier'
import QuizTemplateClient from '@/services/resource_client/quiz_template'
import ParkQuizClient, {PARK_QUIZ_TEMPLATE_UUID, PARK_QUIZ_STATUS_UNANSWERED, PARK_QUIZ_STATUS_ANSWERED, PARK_QUIZ_STATUS_WAITING_APPROVAL} from '@/services/resource_client/park_quiz'
import QuizEvaluationClient from '@/services/resource_client/quiz_evaluation'
import DateQuestion from './questions/DateQuestion'
import MultipleChoiceQuestion from './questions/MultipleChoiceQuestion'
import CollectionQuestion from './questions/CollectionQuestion'
import BooleanFormQuestion from './questions/BooleanFormQuestion'
import BooleanCollectionQuestion from './questions/BooleanCollectionQuestion'
import FormQuestion from './questions/FormQuestion'
import ItemsQuestion from './questions/ItemsQuestion'
import AccelerationProgramItemsQuestion from './questions/AccelerationProgramItemsQuestion'
import AssociationProgramItemsQuestion from './questions/AssociationProgramItemsQuestion'
import CoworkingProgramItemsQuestion from './questions/CoworkingProgramItemsQuestion'
import IncubationProgramItemsQuestion from './questions/IncubationProgramItemsQuestion'
import PreIncubationProgramItemsQuestion from './questions/PreIncubationProgramItemsQuestion'
import ResidencyProgramItemsQuestion from './questions/ResidencyProgramItemsQuestion'
import OwnRevenuesQuestion from './questions/OwnRevenuesQuestion'
import FinanceIndicatorsQuestion from './questions/FinanceIndicatorsQuestion'
import { responseContainsCpfCnpjValidationError } from '@/utils/quizValidationErrors'

export default {
  name: 'ParkQuiz',
  components: {Adminlte, GoBackButton, Notifier, tabs, tab},
  props: ['parkId', 'referenceYear', 'quizUuid'],
  data () {
    return {
      questionsByAxis: {},
      quiz: null,
      quizEvaluation: {},
      componentsPerType: {
        'date': DateQuestion,
        'multiple-choice': MultipleChoiceQuestion,
        'collection': CollectionQuestion,
        'boolean-form': BooleanFormQuestion,
        'boolean-collection': BooleanCollectionQuestion,
        'form': FormQuestion,
        'items': ItemsQuestion
      },
      customComponentsPerQuestionUuid: {
        'ec210184-aae4-467b-b67b-41e2bb4ec248': AccelerationProgramItemsQuestion,
        'debead3c-5c14-4858-a9f0-5015b89d660c': AccelerationProgramItemsQuestion,
        '3b776879-6b54-49ee-8c0c-cd2ed248fe8c': AssociationProgramItemsQuestion,
        'ea306bbe-5372-4227-810e-2e03a37359ca': AssociationProgramItemsQuestion,
        'd35c23ef-3212-4d3d-84e9-5c259e9322f9': CoworkingProgramItemsQuestion,
        '058138e8-b55c-4e0f-9f2b-ec3be0ebd421': IncubationProgramItemsQuestion,
        'd183149d-ea40-49c1-961e-da109a3ee94f': IncubationProgramItemsQuestion,
        '4d59ba81-3b4d-4261-b892-f9a0987e2922': IncubationProgramItemsQuestion,
        '1badbc7c-74a9-44f0-a389-1bc55c317573': IncubationProgramItemsQuestion,
        '8a7dfc6e-2b34-4c32-bccb-af968c948493': PreIncubationProgramItemsQuestion,
        'bf704709-1bd9-4617-b2a8-5298ef3280d4': PreIncubationProgramItemsQuestion,
        'dca08a13-f0e2-4be1-9686-0f14837e2373': ResidencyProgramItemsQuestion,
        'eb4d4380-1651-43c4-9459-8d93c89f493d': ResidencyProgramItemsQuestion,
        '6b023903-50e0-48ab-8942-6b56c78ddb1a': OwnRevenuesQuestion,
        'b234f9fb-c8af-4ee1-85fd-3d4dc4072cbb': FinanceIndicatorsQuestion
      },
      activeAxis: 0
    }
  },
  mounted () {
    this.getQuizTemplate()

    if (!this.quizUuid) {
      this.createParkQuiz()
      return
    }

    this.getQuiz().then(() => {
      this.getQuizEvaluation()
    })

    $('#send-for-approval-modal').on('hidden.bs.modal', this.scrollToTop)
  },
  computed: {
    isQuizAllowedToBeSent () {
      return this.quiz !== null && this.quiz.status !== PARK_QUIZ_STATUS_UNANSWERED
    },
    activeAxisName () {
      return Object.keys(this.questionsByAxis)[this.activeAxis]
    }
  },
  methods: {
    setActiveAxis (index) {
      this.activeAxis = index
    },
    getQuizTemplate () {
      QuizTemplateClient.get(PARK_QUIZ_TEMPLATE_UUID, this.parkId).then(r => {
        this.questionsByAxis = this.getQuestionsByAxis(r.data.questions)
      })
    },
    createParkQuiz () {
      ParkQuizClient
      .post(this.parkId, this.referenceYear)
      .then(r => {
        this.quiz = r.data

        if (this.existsAnyManagementAxisQuestionAnswered()) {
          this.showUpdateAnswersNotification()
        }
      })
    },
    existsAnyManagementAxisQuestionAnswered () {
      const managementAxisQuestions = this.questionsByAxis['Gestão']
      for (const question of managementAxisQuestions) {
        for (const answer of Object.values(this.quiz.answers)) {
          if (answer.questionUuid === question.uuid && answer.value) {
            return true
          }
        }
      }
      return false
    },
    getQuiz () {
      return ParkQuizClient
      .getByYear(this.parkId, this.referenceYear)
      .then(r => {
        this.quiz = r.data[0]
      })
    },
    hasQuizEvaluation () {
      return this.quizEvaluation && Object.keys(this.quizEvaluation).length > 0
    },
    getQuizEvaluation () {
      QuizEvaluationClient.byParkQuizUuid(this.quiz.uuid)
        .then((r) => {
          if (r.data.total > 0) {
            this.quizEvaluation = r.data[0]
          }
        })
    },
    axisHeader (axisName) {
      if (!this.hasQuizEvaluation()) {
        return axisName
      }
      if (this.quizEvaluation.approvedAxis.includes(axisName)) {
        return `<i class="fa fa-check-square-o text-green"></i> ${axisName}`
      }
      if (this.quizEvaluation.disapprovedAxis.includes(axisName)) {
        return `<i class="fa fa-window-close-o text-danger"></i> ${axisName}`
      }
      return `<i class="fa fa-square-o"></i> ${axisName}`
    },
    getQuestionsByAxis (questions) {
      let questionsByAxis = this.sortQuestionsByAxis(questions)
      Object.keys(questionsByAxis).forEach(k => {
        questionsByAxis[k] = this.sortQuestionsByRenderingOrder(questionsByAxis[k])
      })
      return questionsByAxis
    },
    sortQuestionsByAxis (questions) {
      let questionsByAxis = {
        'Gestão': [],
        'Serviços': [],
        'Infraestrutura': [],
        'Equipe': [],
        'Parceiros': []
      }
      questions.forEach(e => {
        let axis = e.axis
        if (!questionsByAxis.hasOwnProperty(e.axis)) {
          questionsByAxis[axis] = []
        }
        questionsByAxis[axis].push(e)
      })
      return questionsByAxis
    },
    sortQuestionsByRenderingOrder (questions) {
      questions.sort(function (a, b) {
        return a.renderingOrder - b.renderingOrder
      })
      return questions
    },
    onAnswerUpdated (answer) {
      let questionFound = false
      this.quiz.answers.forEach(a => {
        if (a.questionUuid === answer.questionUuid) {
          a.value = answer.value
          questionFound = true
          return
        }
      })
      if (!questionFound) {
        throw new Error('AnswerNotFoundException')
      }
    },
    getQuestionComponent (q) {
      if (this.customComponentsPerQuestionUuid.hasOwnProperty(q.uuid)) {
        return this.customComponentsPerQuestionUuid[q.uuid]
      }
      return this.componentsPerType[q.type]
    },
    getQuestionAnswer (q) {
      if (!q.isVisible || this.quiz === null) {
        return
      }
      for (let answerIndex in this.quiz.answers) {
        let answer = this.quiz.answers[answerIndex]
        if (answer.questionUuid === q.uuid) {
          return answer
        }
      }
      return this.addDefaultAnswerForQuestion(q)
    },
    addDefaultAnswerForQuestion (question) {
      const defaultAnswer = {
        'questionUuid': question.uuid,
        'value': null
      }

      const answersLength = Object.keys(this.quiz.answers).length
      this.$set(this.quiz.answers, answersLength, defaultAnswer)

      return defaultAnswer
    },
    onSubmit () {
      this.saveQuiz()
    },
    saveQuiz () {
      if (!this.isActiveAxisValid()) {
        this.showActiveAxisErrorNotification()
        return
      }
      setTimeout(() => {
        ParkQuizClient
          .put(this.quiz.uuid, PARK_QUIZ_STATUS_ANSWERED, this.quiz.answers.filter(this.checkEmptyAnswer), this.activeAxisName)
          .then((response) => {
            this.showSavedFormNotification()
            this.quiz.status = response.data.status
          })
          .catch(e => {
            this.notifyParkQuizSubmitError(e)
          })
      }, 0)
    },
    isActiveAxisValid () {
      let isValid = true
      this.$refs.questions.forEach(child => {
        if (!child.isValid() && child.question && child.question.axis === this.activeAxisName) {
          isValid = false
        }
      })
      return isValid
    },
    sendQuiz () {
      $('#send-for-approval-modal').modal('toggle')

      if (!this.areAllAxesValid()) {
        this.activateFirstInvalidAxis()
        this.showActiveAxisErrorNotification()
        return
      }

      setTimeout(() => {
        ParkQuizClient
          .put(this.quiz.uuid, PARK_QUIZ_STATUS_WAITING_APPROVAL, this.quiz.answers.filter(this.checkEmptyAnswer))
          .then((response) => {
            this.showSavedFormNotification()
            this.quiz.status = response.data.status
            this.$router.push({name: 'ParkHome'})
          })
          .catch(e => {
            this.notifyParkQuizSubmitError(e)
          })
      }, 0)
    },
    areAllAxesValid () {
      let isValid = true
      this.$refs.questions.forEach(child => {
        if (!child.isValid()) {
          isValid = false
        }
      })
      return isValid
    },
    activateFirstInvalidAxis () {
      for (let i = 0; i < this.$refs.questions.length; i++) {
        const child = this.$refs.questions[i]
        if (!child.isValid()) {
          this.activeAxis = Object.keys(this.questionsByAxis).indexOf(child.question.axis)
          return
        }
      }
    },
    checkEmptyAnswer (answer) {
      return answer.value !== null
    },
    showUpdateAnswersNotification () {
      this.$notify({
        type: 'warning',
        title: 'Atenção',
        text: 'As respostas a seguir foram recuperadas de seu último questionário respondido. Por favor, verifique-as e atualize as informações necessárias!',
        duration: 30000
      })
      this.scrollToTop()
    },
    showSavedFormNotification () {
      this.$notify({ type: 'success', title: 'Sucesso', text: 'As informações foram salvas!' })
      this.scrollToTop()
    },
    showErrorNotification () {
      this.$notify({ type: 'error', title: 'Ocorreu um erro', text: 'Verifique se as informações foram preenchidas corretamente e tente novamente.' })
      this.scrollToTop()
    },
    showActiveAxisErrorNotification () {
      this.$notify({ type: 'error', title: 'Eixo inválido', text: 'Este eixo do questionário possui respostas inválidas.' })
      this.scrollToTop()
    },
    showUnexpectedErrorNotification () {
      this.$notify({ type: 'error', title: 'Ocorreu um erro inesperado', text: 'Por favor, entre em contato com nossa equipe relatando o problema.' })
      this.scrollToTop()
    },
    notifyParkQuizSubmitError (e) {
      const payload = e.response && e.response.data ? e.response.data : null
      if (payload && payload.errors) {
        this.errors = payload.errors
      } else {
        this.errors = null
      }
      if (responseContainsCpfCnpjValidationError(payload)) {
        this.$notify({
          type: 'error',
          title: 'CPF ou CNPJ inválido',
          text: 'Corrija os documentos informados no questionário e tente novamente.'
        })
        this.scrollToTop()
        return
      }
      this.showUnexpectedErrorNotification()
    },
    scrollToTop () {
      setTimeout(() => {
        window.scrollTo(0, 0)
      }, 0)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ParkQuiz.vue?143e8232